import { useQuery } from "@tanstack/react-query";
import type { FundingApplicationUnauthenticatedSchemas } from "@wayflyer/api-types";
import { useAxios } from "@wayflyer/auth-sdk";

export const useLandingPageViewProperties = () => {
  const client = useAxios();
  const url = "/funding/api/invite/ef-landing-page-view";

  return useQuery({
    queryKey: [url],
    queryFn: () => client.get<FundingApplicationUnauthenticatedSchemas.LandingPageViewPropertiesOut>(url),
    select: ({ data }) => data,
    retry: false, // Don't retry on 404 - it just means no valid invite token
    enabled: false, // Only fetch when explicitly called
  });
};
